import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { Spin } from 'antd';
import queryString from 'query-string';

import BaseAlert from 'components/wrappers/BaseAlert';
import { getInvitePartnerExternalData } from 'redux/reducers/partnerSlice';
import { useAppDispatch } from 'hooks/useAppDispatch';

type ParamsProps = {
  invitationId: string;
};

export default function PartnerInvitationPage() {
  const { invitationId } = useParams<ParamsProps>();
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { accept } = queryString.parse(location.search);

  useEffect(() => {
    if (!invitationId) {
      navigate('/login', { replace: true });
      return;
    }

    const loadInitialValues = async () => {
      setIsLoading(true);

      const result = await dispatch(
        getInvitePartnerExternalData({ invitationId, accept }),
      );

      let isLinkValid = true;

      if (getInvitePartnerExternalData.fulfilled.match(result)) {
        if (accept) {
          BaseAlert.success('Partnership has been confirmed.');
          navigate('/', { replace: true });
        } else {
          navigate('/registration', {
            replace: true,
            state: {
              prefilledData: result.payload,
              invitationId,
            },
          });
        }
        return;
      } else {
        isLinkValid = false;
      }

      if (!isLinkValid) {
        BaseAlert.error('The link is invalid.');
        navigate('/login', { replace: true });
      }
    };

    loadInitialValues();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, invitationId]);

  return <>{isLoading && <Spin />}</>;
}
